import type { ComponentProps } from 'react';

import type { SocialSharing } from '@change/ds-core-ui';
import { EmailOutlineIcon } from '@change/ds-icons/EmailOutlineIcon';
import { FacebookIcon } from '@change/ds-icons/FacebookIcon';
import { FacebookMessengerIcon } from '@change/ds-icons/FacebookMessengerIcon';
import { InstagramIcon } from '@change/ds-icons/InstagramIcon';
import { LineIcon } from '@change/ds-icons/LineIcon';
import { LinkIcon } from '@change/ds-icons/LinkIcon';
import { NextDoorIcon } from '@change/ds-icons/NextDoorIcon';
import { RedditIcon } from '@change/ds-icons/RedditIcon';
import { ShareIcon } from '@change/ds-icons/ShareIcon';
import { TikTokIcon } from '@change/ds-icons/TikTokIcon';
import { TwitterIcon } from '@change/ds-icons/TwitterIcon';
import { VkIcon } from '@change/ds-icons/VkIcon';
import { WhatsAppIcon } from '@change/ds-icons/WhatsAppIcon';

import type { RoundShareIconButtonChannel } from './types';

type SocialSharingConfig = {
	icon: React.ReactElement;
	variant: ComponentProps<typeof SocialSharing>['variant'];
};

export const SOCIAL_SHARING_ICON_CONFIG_BY_CHANNEL: Readonly<
	Record<Exclude<RoundShareIconButtonChannel, 'sms'>, SocialSharingConfig>
> = {
	facebook: { icon: <FacebookIcon />, variant: 'facebook' },
	facebookMessenger: { icon: <FacebookMessengerIcon />, variant: 'facebookMessenger' },
	twitter: { icon: <TwitterIcon />, variant: 'twitter' },
	whatsapp: { icon: <WhatsAppIcon />, variant: 'whatsapp' },
	instagram: { icon: <InstagramIcon />, variant: 'instagram' },
	instagramStories: { icon: <InstagramIcon />, variant: 'instagram' },
	nextdoor: { icon: <NextDoorIcon />, variant: 'nextdoor' },
	reddit: { icon: <RedditIcon />, variant: 'reddit' },
	tiktok: { icon: <TikTokIcon />, variant: 'tiktok' },
	vk: { icon: <VkIcon />, variant: 'default' },
	line: { icon: <LineIcon />, variant: 'default' },
	email: { icon: <EmailOutlineIcon />, variant: 'default' },
	copy: { icon: <LinkIcon />, variant: 'default' },
	mobileNativeShare: { icon: <ShareIcon />, variant: 'default' },
};
